import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { Helmet } from 'react-helmet';
const root = <>
    <Helmet data-id="element-1228">
      <title data-id="element-1229">
        Masterclass Gratuita: Vende Productos Digitales Con IA | Gabriel Beltrán
      </title>
      <meta name="description" content="Aprende a crear y vender productos digitales rentables usando IA. Masterclass gratuita con Gabriel Beltrán - 26 de noviembre, 7 PM. Recibe un regalo valorado en $297." data-id="element-1230" />
    </Helmet>
    <AppRouter data-id="element-1231" />
  </>;
render(root, document.getElementById('root'));